var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyrightPolicyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 390,
    viewBox: "0 0 390 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7922_8446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195 0C302.64 0 390 87.36 390 195C390 302.64 302.64 390 195 390C87.36 390 0 302.64 0 195C0 87.36 87.36 0 195 0ZM195 97.5C141.18 97.5 97.5 141.18 97.5 195C97.5289 216.31 104.536 237.023 117.449 253.975C130.362 270.926 148.472 283.182 169.008 288.869C189.545 294.556 211.379 293.361 231.173 285.467C250.966 277.572 267.63 263.413 278.616 245.154L245.174 225.108C238.588 236.076 228.588 244.583 216.706 249.326C204.824 254.068 191.714 254.785 179.386 251.366C167.058 247.947 156.19 240.58 148.448 230.395C140.706 220.21 136.516 207.768 136.52 194.975C136.524 182.181 140.722 169.741 148.471 159.561C156.22 149.381 167.092 142.022 179.423 138.611C191.753 135.2 204.862 135.925 216.741 140.675C228.62 145.426 238.614 153.939 245.193 164.911L278.616 144.826C269.953 130.388 257.697 118.44 243.044 110.146C228.39 101.852 211.838 97.4952 195 97.5Z",
    fill: "#2B00AC",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7922_8446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 390,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrightPolicyIcon);
export default __webpack_public_path__ + "static/media/CopyrightPolicyIcon.f60b527375b185f6fd77198dc29de1e0.svg";
export { ForwardRef as ReactComponent };